import type { FetchError } from 'ofetch';
import type { HttpClient, HttpResponse } from '@/utils/HttpClient';
import type { Campaign } from '@/types/campaign';

export type CampaignService = {
  getActiveCampaigns: () => Promise<HttpResponse<Campaign[], FetchError>>;
  getActiveCustomerCampaigns: () => Promise<HttpResponse<Campaign[], FetchError>>;
  getSelectedProducts: <T>(id: string) => Promise<HttpResponse<T, FetchError>>;
};

export const CampaignService = (httpClient: HttpClient): CampaignService => ({
  getActiveCampaigns() {
    return httpClient({
      endpoint: '/campaigns/active-campaigns',
      requestOptions: {
        ignoreErrorHook: true,
      },
    });
  },
  getActiveCustomerCampaigns() {
    return httpClient({ endpoint: '/campaigns/active-campaigns/customer' });
  },
  getSelectedProducts(id) {
    return httpClient({ endpoint: '/selected-product-groups/' + id });
  },
});
